import { useEffect, useState, useCallback } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FriendSearch from "../components/FriendSearch";
import FriendStatsModal from "../components/FriendStatsModal";
import MyStatsModal from "../components/MyStatsModal";
import { getFriends } from "../services/friendService";
import { getDashboard } from "../services/drinkService";
import { getCurrentUser } from "../services/authService";

const MEDALS = ["🥇", "🥈", "🥉"];

export default function Friends() {
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFriendId, setSelectedFriendId] = useState(null);
  const [showMyStats, setShowMyStats] = useState(false);

  const loadAll = useCallback(async () => {
    const user = getCurrentUser();
    const [friends, myStats] = await Promise.all([getFriends(), getDashboard()]);

    const moi = {
      id: "me",
      pseudo: `${user.pseudo} (toi)`,
      nb_verres: myStats.total_verres,
      alcool_favori: myStats.alcool_favori ? myStats.alcool_favori.nom : null,
      isMe: true,
    };

    const combined = [...friends, moi].sort((a, b) => b.nb_verres - a.nb_verres);
    setRanking(combined);
    setLoading(false);
  }, []);

  useEffect(() => {
    loadAll();
  }, [loadAll]);

  const champion = ranking[0];

  const handleClick = (item) => {
    if (item.isMe) {
      setShowMyStats(true);
    } else {
      setSelectedFriendId(item.id);
    }
  };

  return (
    <>
      <Navbar />
      <main className="page">
        <h1>Tes amis</h1>

        {champion && (
          <div className="card champion-card">
            <span className="champion-badge">👑 Le plus alcoolique</span>
            <span className="champion-name">
              {champion.isMe ? "Toi" : champion.pseudo}
            </span>
            <span className="muted">
              {champion.nb_verres} verres — favori : {champion.alcool_favori || "—"}
            </span>
          </div>
        )}

        <section className="grid-2">
          <FriendSearch onFriendAdded={loadAll} />

          <div className="card">
            <h3>Classement</h3>
            {loading && <p className="muted">Chargement...</p>}
            {!loading && ranking.length === 0 && (
              <p className="muted">Ajoute des amis pour voir le classement.</p>
            )}
            <ol className="ranking-list">
              {ranking.map((f, idx) => (
                <li
                  key={f.id}
                  className={`ranking-item-clickable ${idx < 3 ? "ranking-top3" : ""} ${
                    f.isMe ? "ranking-is-me" : ""
                  }`}
                  onClick={() => handleClick(f)}
                >
                  <span className="ranking-rank">
                    {idx < 3 ? MEDALS[idx] : `#${idx + 1}`}
                  </span>
                  <span className="ranking-name">
                    {f.isMe ? `${f.pseudo}` : f.pseudo}
                  </span>
                  <span className="ranking-detail">
                    {f.nb_verres} verres · {f.alcool_favori || "—"}
                  </span>
                </li>
              ))}
            </ol>
          </div>
        </section>
      </main>
      <Footer />

      {selectedFriendId && (
        <FriendStatsModal
          friendId={selectedFriendId}
          onClose={() => setSelectedFriendId(null)}
        />
      )}
      {showMyStats && <MyStatsModal onClose={() => setShowMyStats(false)} />}
    </>
  );
}